const fileTypes = {
  // Doküman formatları
  pdf: { fileType: "PDF Document", icon: "file-pdf", color: "#FF0000" },
  doc: { fileType: "Word Document", icon: "file-word", color: "#2B579A" },
  docx: { fileType: "Word Document", icon: "file-word", color: "#2B579A" },
  xls: { fileType: "Excel Spreadsheet", icon: "file-excel", color: "#217346" },
  xlsx: { fileType: "Excel Spreadsheet", icon: "file-excel", color: "#217346" },
  ppt: { fileType: "PowerPoint", icon: "file-powerpoint", color: "#D24726" },
  pptx: { fileType: "PowerPoint", icon: "file-powerpoint", color: "#D24726" },
  txt: { fileType: "Text Document", icon: "file-text", color: "#666666" },

  // Görüntü formatları
  jpg: { fileType: "JPEG Image", icon: "file-image", color: "#FFB900" },
  jpeg: { fileType: "JPEG Image", icon: "file-image", color: "#FFB900" },
  png: { fileType: "PNG Image", icon: "file-image", color: "#88C100" },
  gif: { fileType: "GIF Image", icon: "file-image", color: "#00B7C3" },
  bmp: { fileType: "Bitmap Image", icon: "file-image", color: "#00B294" },
  svg: { fileType: "SVG Image", icon: "file-image", color: "#FF9900" },
  tiff: { fileType: "TIFF Image", icon: "file-image", color: "#877DD7" },

  // Ses formatları
  mp3: { fileType: "MP3 Audio", icon: "file-audio", color: "#4C5BD4" },
  wav: { fileType: "WAV Audio", icon: "file-audio", color: "#004E8C" },
  midi: { fileType: "MIDI Audio", icon: "file-audio", color: "#00188F" },

  // Video formatları
  mp4: { fileType: "MP4 Video", icon: "file-video", color: "#E81123" },
  avi: { fileType: "AVI Video", icon: "file-video", color: "#0078D7" },
  mov: { fileType: "QuickTime Video", icon: "file-video", color: "#767676" },
  wmv: {
    fileType: "Windows Media Video",
    icon: "file-video",
    color: "#0063B1",
  },
  flv: { fileType: "Flash Video", icon: "file-video", color: "#E62E2E" },

  // Kod/Programlama formatları
  html: { fileType: "HTML File", icon: "file-html5", color: "#E44D26" },
  css: { fileType: "CSS File", icon: "file-css", color: "#264DE4" },
  js: {
    fileType: "JavaScript File",
    icon: "file-javascript",
    color: "#F7DF1E",
  },
  jsx: {
    fileType: "React JSX File",
    icon: "file-javascript",
    color: "#61DAFB",
  },
  php: { fileType: "PHP File", icon: "file-php", color: "#777BB4" },
  py: { fileType: "Python File", icon: "file-python", color: "#3776AB" },
  java: { fileType: "Java File", icon: "file-java", color: "#007396" },
  rb: { fileType: "Ruby File", icon: "file-ruby", color: "#CC342D" },
  sql: { fileType: "SQL File", icon: "file-sql", color: "#00758F" },

  // Sıkıştırılmış formatlar
  zip: { fileType: "ZIP Archive", icon: "file-zip", color: "#FFAE00" },
  rar: { fileType: "RAR Archive", icon: "file-zip", color: "#3C7FC0" },
  "7z": { fileType: "7-Zip Archive", icon: "file-zip", color: "#757575" },

  // Diğer formatlar
  exe: { fileType: "Executable", icon: "file-exe", color: "#FF4848" },
  iso: { fileType: "Disk Image", icon: "file-iso", color: "#7E7E7E" },
};

export const getFileTypeInfo = (filename) => {
  if (!filename) return { fileType: "Unknown", icon: "", color: "#999999" };

  // Dosya uzantısını al ve küçük harfe çevir
  const extension = filename.split(".").pop().toLowerCase();

  // Eğer uzantı tanımlı değilse varsayılan değerleri döndür
  if (!fileTypes[extension]) {
    return { fileType: "Unknown", icon: "file-alt", color: "#999999" };
  }

  return {
    extension,
    ...fileTypes[extension],
  };
};

// Kullanım örneği:
/*
const fileInfo = getFilefileTypeInfo('document.pdf');
console.log(fileInfo);
// Çıktı: { extension: 'pdf', fileType: 'PDF Document', icon: "", color: '#FF0000' }

const fileInfo2 = getFilefileTypeInfo('image.png');
console.log(fileInfo2);
// Çıktı: { extension: 'png', fileType: 'PNG Image', icon: "", color: '#88C100' }

const fileInfo3 = getFilefileTypeInfo('unknown.xyz');
console.log(fileInfo3);
// Çıktı: { fileType: 'Unknown', icon: "", color: '#999999' }
*/
